var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Routes } from '../const';
import { useMainContext } from '../context';
import { getButtonAnalytics } from '../helpers/getAnalytics';
import useTranslation from './use-translation';
var useSecondaryAction = function (flow, actions) {
    var handleCloseModal = actions.handleCloseModal, navigateTo = actions.navigateTo;
    var _a = useMainContext(), currentRoute = _a.currentRoute, setCurrentRoute = _a.setCurrentRoute;
    var i18n = useTranslation();
    var buttonAnalytics = getButtonAnalytics(currentRoute);
    var survey = flow === null || flow === void 0 ? void 0 : flow.questionnaire;
    var index = survey === null || survey === void 0 ? void 0 : survey.index;
    var handleBack = function () {
        switch (currentRoute) {
            case Routes.SETTLEMENT_START:
            case Routes.PLAN_START:
                setCurrentRoute(Routes.PAYMENT_OPTIONS);
                flow.onResetQuestionnaire();
                return;
            case Routes.SETTLEMENT_QUESTIONNAIRE:
                if (index === 0) {
                    setCurrentRoute(Routes.SETTLEMENT_START);
                }
                else {
                    flow.setQuestionIndex(index - 1);
                }
                return;
            case Routes.SETTLEMENT_OPTIONS:
                flow.setQuestionIndex(index - 1);
                flow.setPlan(null);
                setCurrentRoute(Routes.SETTLEMENT_QUESTIONNAIRE);
                return;
            case Routes.SETTLEMENT_REVIEW:
                setCurrentRoute(Routes.SETTLEMENT_OPTIONS);
                return;
            case Routes.PLAN_QUESTIONNAIRE:
                if (index === 0) {
                    setCurrentRoute(Routes.PLAN_START);
                }
                else {
                    flow.setQuestionIndex(index - 1);
                }
                return;
            case Routes.PLAN_REVIEW:
                setCurrentRoute(Routes.PLAN_QUESTIONNAIRE);
                return;
            case Routes.PLAN_CONFIRM:
                setCurrentRoute(Routes.PLAN_REVIEW);
                break;
            default:
        }
    };
    var closeButtonText = i18n('questionnaireFooter.closeButton');
    return function () {
        var backToPaymentOptionsButtonText = i18n('questionnaireFooter.backToPaymentOptions');
        var cancelButtonText = 'questionnaireFooter.cancelButton';
        var questionnaireSecondaryText = index !== 0
            ? 'questionnaireFooter.previousQuestionButton'
            : cancelButtonText;
        var secondaryBtnAnalytics = index !== 0 ? 'previous question' : 'back';
        switch (currentRoute) {
            case Routes.SETTLEMENT_START:
            case Routes.PLAN_START:
                return __assign(__assign({ text: backToPaymentOptionsButtonText, action: handleBack }, buttonAnalytics), { dataReason: 'back to payment options' });
            case Routes.SETTLEMENT_SUCCESS:
            case Routes.PAYMENT_OPTIONS:
            case Routes.SETTLEMENT_CONTACT:
            case Routes.PLAN_CONTACT:
            case Routes.PLAN_FORBEARANCE:
                return __assign(__assign({ text: closeButtonText, action: handleCloseModal }, buttonAnalytics), { dataReason: 'close' });
            case Routes.SETTLEMENT_OPTIONS:
                return __assign(__assign({ text: i18n('plan.otherPaymentOptionsButton'), action: function () { return setCurrentRoute(Routes.PAYMENT_OPTIONS); } }, buttonAnalytics), { dataReason: 'back to payment options' });
            case Routes.PLAN_REVIEW:
                return __assign(__assign({ text: i18n(cancelButtonText), action: handleBack }, buttonAnalytics), { dataReason: 'back' });
            case Routes.PLAN_CONFIRM:
                return __assign(__assign({ text: i18n('questionnaireFooter.dontEnrollButton'), action: handleBack }, buttonAnalytics), { dataReason: 'back' });
            case Routes.SETTLEMENT_QUESTIONNAIRE:
            case Routes.PLAN_QUESTIONNAIRE:
                return __assign(__assign({ text: i18n(questionnaireSecondaryText), action: handleBack }, buttonAnalytics), { dataReason: secondaryBtnAnalytics });
            case Routes.SETTLEMENT_REVIEW:
                return __assign(__assign({ text: i18n('questionnaireFooter.changePlanButton'), action: handleBack }, buttonAnalytics), { dataReason: 'change plan selection' });
            case Routes.PLAN_SUCCESS:
                return __assign(__assign({ text: i18n('plan.successSecondaryButton') }, buttonAnalytics), { dataReason: i18n('plan.successSecondaryButton'), action: function () { return navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo('payment'); } });
            default:
                return null;
        }
    };
};
export default useSecondaryAction;
//# sourceMappingURL=use-secondary-action.js.map